import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        canManageCourse: '<',
        targets: '<',
        isOptional: '<'
    },
    template: `
            <div class="tablewrapper">
                <list-empty list="vm.targets" show-add-message="true"></list-empty>
                <table class="data01 col-4" datatable dt-options="vm.DATATABLES" ng-if="vm.targets.length">
                    <thead>
                    <tr>
                        <th>{{ 'courses.Department' | translate }}</th>
                        <th>{{ 'courses.Role' | translate }}</th>
                        <th>{{ 'courses.Level' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="drl in vm.targets">
                        <td>
                            <span ng-if="drl.departmentName">{{ drl.departmentName }}</span>
                            <span ng-if="!drl.departmentName">{{ 'courses.All departments' | translate }}</span>
                        </td>
                        <td>
                            <span ng-if="drl.roleName">{{ drl.roleName }}</span>
                            <span ng-if="!drl.roleName">{{ 'courses.All roles' | translate }}</span>
                        </td>
                        <td>
                            <span ng-if="drl.levelName">{{ drl.levelName }}</span>
                            <span ng-if="!drl.levelName">{{ 'courses.All levels' | translate }}</span>
                        </td>
                        <td class="actions">
                            <a class="btn edit"
                                ng-if="vm.canManageCourse"
                                ng-click="vm.manageTarget(drl.id)"
                            >{{ 'general.Edit' | translate }}</a>
                            <a class="btn delete"
                                ng-if="vm.canManageCourse"
                                ng-click="vm.removeDrl(drl.id)"
                            >{{ 'general.Remove' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        `
})

export default class {
    constructor ($scope, DATATABLES, COURSE_TARGET_NEED_TYPE_ENUM, TokenService) {
        this.$scope = $scope;
        this.TokenService = TokenService;
        this.DATATABLES = DATATABLES;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
    }

    manageTarget (id) {
        this.$scope.$parent.vm.manageTarget(id);
    }

    removeDrl (id) {
        this.$scope.$parent.vm.removeDrl(id, false, this.isOptional);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/target/list/index.js